import React, { useEffect, useRef, useState } from "react";
import lottie from "lottie-web";
import animationData from "../assets/plane-loading.json";

const LottieLoader = ({ size = "300px", className = "", style = {} }) => {
    const containerRef = useRef(null);
    const animationRef = useRef(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (containerRef.current) {
            try {
                // Clear any existing animation
                if (animationRef.current) {
                    animationRef.current.destroy();
                }

                // Create new animation
                animationRef.current = lottie.loadAnimation({
                    container: containerRef.current,
                    renderer: "svg",
                    loop: true,
                    autoplay: true,
                    animationData: animationData,
                });
            } catch (err) {
                console.error("Error loading Lottie animation:", err);
                setError(err.message);
            }

            // Cleanup on unmount
            return () => {
                if (animationRef.current) {
                    animationRef.current.destroy();
                }
            };
        }
    }, []);

    if (error) {
        return (
            <div
                style={{
                    width: size,
                    height: size,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    ...style,
                }}
                className={className}
            >
                <div style={{ fontSize: "12px", color: "#999" }}>Loading...</div>
            </div>
        );
    }

    return (
        <div
            ref={containerRef}
            style={{
                width: size,
                height: size,
                display: "inline-block",
                ...style,
            }}
            className={className}
        />
    );
};

export default LottieLoader;

